module.exports = __webpack_public_path__ + "static/media/new-chapter-img.bf85bfb8.jpeg";